
export default {

    ClearRedSvg: function() {

        return `<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"14\" height=\"14\" viewBox=\"0 0 18 18\">\n" +
                    "<defs>\n" +
                    "<clipPath id=\"clip-Clear_Red\">\n" +
                    "<rect width=\"24\" height=\"24\"/>\n" +
                    "</clipPath>\n" +
                    "</defs>
                    "<g id=\"Clear_Red\"clip-path=\"url(#clip-Clear_Red)\">\n" +
                    "<rect width=\"24\" height=\"24\" fill=\"rgba(81,91,96,0)\"/>\n" +
                    "<g id=\"Group_13343\" data-name=\"Group 13343">\n" +
                    "<path id="Path_62" data-name="Path 62" d="M0,0H24V24H0Z" stroke="rgba(0,0,0,0)" stroke-width="1" opacity="0"/> \n" +
                    "  <path id="Path_63" class="svg-primary-color" data-name="Path 63" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" stroke="rgba(0,0,0,0)" stroke-width="1"/>\n" +
                    "</g>\n" +
                    "</g>\n" +
                    "</svg>`
    }
};



// WEBPACK FOOTER //
// ./src/common/plugins/svg/ClearRedPlugin.js